// extracted by mini-css-extract-plugin
export var notificationHost = "_fk-0";